import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/header/wallet-dialog/metamask.png'
import _imports_1 from '../assets/images/header/wallet-dialog/wallet-connect.png'
import _imports_2 from '../assets/images/header/wallet-dialog/graph.png'


const _withScopeId = n => (_pushScopeId("data-v-c73da8dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-close-fill" }, null, -1))
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-paw" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "metamask"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Metamask")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-arrow-right" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "wallet-img",
    src: _imports_1,
    alt: "wallet connect"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "name" }, "WalletConnect")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-arrow-right" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))

import { computed } from 'vue';
import WalletConnectProvider from '@walletconnect/web3-provider';
import { addSubscribersForMetamaskEvents, getProvider, setupStore } from '@/common/get-web3';
import { useStore } from '@/store';
import { WalletConnectMethod } from '@/store/state';


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: Boolean,
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props

const store = useStore();





const innerVisible = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});

async function connectMetamask() {
  const provider = await getProvider();
  if (provider) {
    const accounts = await provider.request({ method: 'eth_requestAccounts' });
    if (accounts[0]) {
      await setupStore(provider, store, WalletConnectMethod.Metamask);
    }
    addSubscribersForMetamaskEvents(provider);
    innerVisible.value = false;
  }
}

async function walletConnect() {
  const provider = new WalletConnectProvider({
    rpc: {
      56: 'https://bsc-dataseed.binance.org/',
      97: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
    },
  });

  provider.enable().then((accounts: string[]) => {
    console.log(accounts[0]);
    setupStore(provider, store, WalletConnectMethod.Walletconnect);
    addSubscribersForMetamaskEvents(provider);
    innerVisible.value = false;
  });
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(innerVisible),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(innerVisible) ? (innerVisible).value = $event : null)),
    "custom-class": "neco-dialog wallet-dialog",
    width: "600px",
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (innerVisible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('connectWallet')), 1)
        ]),
        _createElementVNode("div", { class: "wallet-content main-content" }, [
          _createElementVNode("div", { class: "wallet-list" }, [
            _createElementVNode("div", {
              class: "item",
              onClick: connectMetamask
            }, _hoisted_7),
            _createElementVNode("div", {
              class: "item",
              onClick: walletConnect
            }, _hoisted_10)
          ]),
          _hoisted_11
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})